__turbopack_context__.v({
  "bottomShade": "Gy9IPW_bottomShade",
  "hero": "Gy9IPW_hero",
  "video": "Gy9IPW_video",
  "videoWrapper": "Gy9IPW_videoWrapper",
});
